import { useCallback, useRef, useState } from "react";
import CrossIcon from "../../icons/crossicon";
import Webcam from "react-webcam";
import TrashBinIcon from "../../icons/trashBinIcon";
import CameraCaptureIcon from "../../icons/cameraCaptureIcon";
import AirPlaneIcon from "../../icons/airPlaneIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useImageContext } from "../../contexts/ImageContext";

export default function Camera() {
  const [picture, setPicture] = useState("");
  const navigate = useNavigate();
  const webcamRef = useRef(null);
  const location = useLocation();
  const { setCapturedImage } = useImageContext();

  const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user",
  };

  const capture = useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    setPicture(pictureSrc);
    setCapturedImage(pictureSrc);
  }, [webcamRef]);

  const handleClose = () => {
    navigate(-1);
  };

  const handleDelete = () => {
    setPicture("");
  };

  const handleSendToGallery = () => {
    if (picture) {
      navigate("/phoneVerification", {
        state: { from: location.pathname, picture },
      });
    }
  };

  return (
    <div className="absolute top-0 left-0 flex items-center justify-center w-full h-[100vh] bg-black bg-opacity-75">
      <span
        className="absolute top-8 left-8 rtl:left-auto rtl:right-8 rounded-full bg-[#7e7770] flex items-center justify-center cursor-pointer z-50 size-[4dvh]"
        onClick={handleClose}
      >
        <CrossIcon className={"size-[2dvh]"} />
      </span>

      {!picture ? (
        <>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            className="object-cover w-full h-full"
          />
          <button
            className="bg-mainActive rounded-full size-[7dvh] border-[.2dvh] border-white flex items-center justify-center absolute bottom-10 left-1/2 -translate-x-1/2"
            type="button"
            onClick={capture}
          >
            <CameraCaptureIcon className="size-[3dvh]" />
          </button>
        </>
      ) : (
        <div className="w-full h-full">
          <img
            src={picture}
            alt="Captured"
            className="object-cover w-full h-full rounded-lg"
            loading="lazy"
          />
          <div className="absolute bottom-0 flex items-center justify-between w-full p-3 -translate-x-1/2 rounded-bl-none rounded-br-none rounded-3xl bg-offWhite left-1/2">
            <button
              type="button"
              onClick={handleDelete}
              className="w-1/2 rounded-[0.5dvh] hover:bg-secondary hover:font-bold group py-[0.4dvh] text-[3dvh]"
            >
              <TrashBinIcon className="size-[2dvh] mx-auto group-hover:*:stroke-black" />
              Delete
            </button>
            <button
              type="button"
              className="w-1/2 rounded-[0.5dvh] hover:bg-secondary hover:font-bold group py-[0.4dvh] text-[3dvh]"
              onClick={handleSendToGallery}
            >
              <AirPlaneIcon className="size-[2dvh] mx-auto group-hover:*:*:stroke-black" />
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
